import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SystemSelector = ({ systems, selectedSystem, onSelectSystem }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  // Filter systems based on search term
  const filteredSystems = systems.filter(system =>
    system.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  return (
    <div className="system-selector">
      <div className="search-container">
        <input
          type="text"
          placeholder="Search health systems..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      <div className="systems-list-header">
        <div className="system-name-header">Health System Name</div>
        <div className="patient-count-header">Patient Count</div>
      </div>
      
      <div className="systems-list">
        {filteredSystems.length > 0 ? (
          filteredSystems.map(system => (
            <div
              key={system.id}
              className={`system-item ${selectedSystem?.id === system.id ? 'selected' : ''}`}
              onClick={() => onSelectSystem(system)}
            >
              <div className="system-name">{system.name}</div>
              <div className="patient-count">{system.patientCount.toLocaleString()}</div>
            </div>
          ))
        ) : (
          <div className="no-results">No health systems match your search.</div>
        )}
      </div>
    </div>
  );
};

SystemSelector.propTypes = {
  systems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      patientCount: PropTypes.number.isRequired,
    })
  ).isRequired,
  selectedSystem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    patientCount: PropTypes.number.isRequired,
  }),
  onSelectSystem: PropTypes.func.isRequired,
};

export default SystemSelector; 